import {Injectable} from '@angular/core';
import {ApiService} from '@app/shared/services/api.service';
import {of} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  constructor(private apiService: ApiService) {
  }

  getClients = (search: string) => {
    if (search !== '' && search !== ' ') {
      return this.apiService.get(`/clients/search-name/${search}`);
    } else {
      return of([]);
    }
  };

  getClientsByPhone = (search: string) => {
    if (search !== '' && search !== ' ') {
      return this.apiService.get(`/clients/search-phone/${search}`);
    } else {
      return of([]);
    }
  };

  getClientTokenById = (id: number) => this.apiService.get(`/clients/${id}/token`);

  getAllClients = () => this.apiService.get(`/clients/`);


  getUserInfoByToken = (clientToken: string) =>
    this.apiService.get('/my/info', {}, {Authorization: `Bearer ${clientToken}`});

  getManagerInfo = (managerId: number) =>
    this.apiService.get(`/manager/${managerId}`);

  getManagersByFilialId = (id: number) =>
    this.apiService.get(`/manager/filial-agency/${id}`);

  getSortedManagersByFilialId = (id: number) =>
    this.apiService.get(`/filial-agency/${id}/managers/`);

  getManagerByHeadManger = () =>
    this.apiService.get(`/queue-slot/head-manager/my-managers`);
}
